import { useNavigate } from 'react-router';
import Notification from '..';
import { NotificationMetadata, NotificationTimestamp, NotificationTitle } from '../blocks';
import { format } from 'date-fns';

const CustomerInstructionsAddedNotification = ({ notification, handleCloseNotification }) => {
    const navigate = useNavigate();

    return (
        <Notification
            notification={notification}
            onClickHandler={() => {
                navigate(`/order/${notification.notification_data?.order_id}`);
                handleCloseNotification();
            }}
        >
            <NotificationTitle>Customer Instructions Added</NotificationTitle>
            <NotificationMetadata>A customer has added special instructions to their order</NotificationMetadata>
            <NotificationMetadata>
                Instructions: {notification.notification_data?.customer_instructions || '--'}
            </NotificationMetadata>
            <NotificationTimestamp>
                {format(new Date(notification.created_at), 'MMM dd, yyyy @ hh:mm a')}
            </NotificationTimestamp>
        </Notification>
    );
};

export default CustomerInstructionsAddedNotification;
